<template>
  <div>
    <b-alert
      :show="dismissCountDown"
      variant="primary"
      @dismiss-count-down="countDownChanged"
    >
      <p><slot></slot>, redirect in {{ dismissCountDown }} seconds...</p>
      <b-progress
        variant="success"
        :max="dismissSecs"
        :value="dismissCountDown"
        height="2px"
      ></b-progress>
    </b-alert>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
    redirectName: String
  },
  data () {
    return {
      dismissCountDown: 0,
      dismissSecs: 2,
      item: 0,
      showDismissibleAlert: false
    };
  },
  methods: {
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    }
  },
  watch: {
    dismissCountDown (value) {
      if (0 === value) {
        if (this.redirectName) {
          this.$router.push({ name: this.redirectName });
        } else {
          this.$router.go(-1);
        }
      }
    },
    show (value) {
      if (value) {
        this.dismissCountDown = 2;
      }
    }
  }
};
</script>
